import React, { Component } from "react";
import { Grid, Divider } from "semantic-ui-react";
class UnpaidInv extends Component {

  HandleHeader() {
    if (this.props.invoices) {
      if (this.props.invoices.length > 0) {
        return "The Following Invoices are not paid in full";
      } else {
        return "All invoices are paid.";
      }
    }
  }
  render() {
    console.log(this.props.unpaidInv);
    return (
      <div className="UnpaidInv">
        <Grid>
          <Grid.Row centered>
            <h2> {this.HandleHeader()}</h2>
          </Grid.Row>
          <Divider />
          <Grid.Row centered />
        </Grid>
      </div>
    );
  }
}
export default UnpaidInv;



// WEBPACK FOOTER //
// ./src/components/accounting/invoices/unpaidinvoices.jsx